module.exports = __webpack_public_path__ + "static/img/header_bg.c1c9f70.png";


//////////////////
// WEBPACK FOOTER
// ./static/header_bg.png
// module id = 8yhl
// module chunks = 1